var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('body',[_c('div',{staticStyle:{"height":"100%","overflow-y":"auto"}},[_c('apidoc')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }